// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WelcomeToFairLicensing_welcomeToFairLicensingContainer__QUYbE {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 470px;
  padding: 95px;
  box-sizing: border-box;
}

.WelcomeToFairLicensing_welcomeToFairLicensingTextContainer__8s6Qu {
  max-width: 370px;
}

.WelcomeToFairLicensing_welcomeToFairLicensingTitle__NCi1w {
  font-size: 22px !important;
  font-weight: bold;
  margin-bottom: 30px !important;
}

.WelcomeToFairLicensing_welcomeToFairLicensingSubtitle__7YWZH {
  font-size: 22px !important;
  margin-bottom: 30px !important;
}

.WelcomeToFairLicensing_welcomeToFairLicensingEmail__1YMum {
  color: var(--color-font-blue);
}

.WelcomeToFairLicensing_welcomeToFairLicensingCopy__SIoXv {
  font-size: 16px;
}

.WelcomeToFairLicensing_welcomeToFairLicensingImage__mu-5X {
  height: 180px;
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/components/WelcomeToFairLicensing/WelcomeToFairLicensing.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB","sourcesContent":[".welcomeToFairLicensingContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  height: 470px;\n  padding: 95px;\n  box-sizing: border-box;\n}\n\n.welcomeToFairLicensingTextContainer {\n  max-width: 370px;\n}\n\n.welcomeToFairLicensingTitle {\n  font-size: 22px !important;\n  font-weight: bold;\n  margin-bottom: 30px !important;\n}\n\n.welcomeToFairLicensingSubtitle {\n  font-size: 22px !important;\n  margin-bottom: 30px !important;\n}\n\n.welcomeToFairLicensingEmail {\n  color: var(--color-font-blue);\n}\n\n.welcomeToFairLicensingCopy {\n  font-size: 16px;\n}\n\n.welcomeToFairLicensingImage {\n  height: 180px;\n  margin: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"welcomeToFairLicensingContainer": `WelcomeToFairLicensing_welcomeToFairLicensingContainer__QUYbE`,
	"welcomeToFairLicensingTextContainer": `WelcomeToFairLicensing_welcomeToFairLicensingTextContainer__8s6Qu`,
	"welcomeToFairLicensingTitle": `WelcomeToFairLicensing_welcomeToFairLicensingTitle__NCi1w`,
	"welcomeToFairLicensingSubtitle": `WelcomeToFairLicensing_welcomeToFairLicensingSubtitle__7YWZH`,
	"welcomeToFairLicensingEmail": `WelcomeToFairLicensing_welcomeToFairLicensingEmail__1YMum`,
	"welcomeToFairLicensingCopy": `WelcomeToFairLicensing_welcomeToFairLicensingCopy__SIoXv`,
	"welcomeToFairLicensingImage": `WelcomeToFairLicensing_welcomeToFairLicensingImage__mu-5X`
};
export default ___CSS_LOADER_EXPORT___;
